(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45987);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90270);
/* harmony import */ var _styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59693);
/* harmony import */ var _ButtonBase__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41810);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93871);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.typography.button, {
      boxSizing: 'border-box',
      minWidth: 64,
      padding: '6px 16px',
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.primary,
      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }),

    /* Styles applied to the span element that wraps the children. */
    label: {
      width: '100%',
      // Ensure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },

    /* Styles applied to the root element if `variant="text"`. */
    text: {
      padding: '6px 8px'
    },

    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      padding: '5px 15px',
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabledBackground)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat((0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.primary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.primary.main),
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat((0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.secondary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.secondary.main),
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabled)
      }
    },

    /* Styles applied to the root element if `variant="contained"`. */
    contained: {
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      boxShadow: theme.shadows[2],
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        boxShadow: theme.shadows[4],
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          boxShadow: theme.shadows[2],
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        }
      },
      '&$focusVisible': {
        boxShadow: theme.shadows[6]
      },
      '&:active': {
        boxShadow: theme.shadows[8]
      },
      '&$disabled': {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */
    containedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */
    containedSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Styles applied to the root element if `disableElevation={true}`. */
    disableElevation: {
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none'
      },
      '&$focusVisible': {
        boxShadow: 'none'
      },
      '&:active': {
        boxShadow: 'none'
      },
      '&$disabled': {
        boxShadow: 'none'
      }
    },

    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit',
      borderColor: 'currentColor'
    },

    /* Styles applied to the root element if `size="small"` and `variant="text"`. */
    textSizeSmall: {
      padding: '4px 5px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="text"`. */
    textSizeLarge: {
      padding: '8px 11px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */
    outlinedSizeSmall: {
      padding: '3px 9px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */
    outlinedSizeLarge: {
      padding: '7px 21px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"` and `variant="contained"`. */
    containedSizeSmall: {
      padding: '4px 10px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="contained"`. */
    containedSizeLarge: {
      padding: '8px 22px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {},

    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the startIcon element if supplied. */
    startIcon: {
      display: 'inherit',
      marginRight: 8,
      marginLeft: -4,
      '&$iconSizeSmall': {
        marginLeft: -2
      }
    },

    /* Styles applied to the endIcon element if supplied. */
    endIcon: {
      display: 'inherit',
      marginRight: -4,
      marginLeft: 8,
      '&$iconSizeSmall': {
        marginRight: -2
      }
    },

    /* Styles applied to the icon element if supplied and `size="small"`. */
    iconSizeSmall: {
      '& > *:first-child': {
        fontSize: 18
      }
    },

    /* Styles applied to the icon element if supplied and `size="medium"`. */
    iconSizeMedium: {
      '& > *:first-child': {
        fontSize: 20
      }
    },

    /* Styles applied to the icon element if supplied and `size="large"`. */
    iconSizeLarge: {
      '& > *:first-child': {
        fontSize: 22
      }
    }
  };
};
var Button = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Button(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableElevati = props.disableElevation,
      disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      endIconProp = props.endIcon,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      startIconProp = props.startIcon,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'text' : _props$variant,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]);

  var startIcon = startIconProp && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.startIcon, classes["iconSize".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(size))])
  }, startIconProp);
  var endIcon = endIconProp && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.endIcon, classes["iconSize".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(size))])
  }, endIconProp);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ButtonBase__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, classes[variant], className, color === 'inherit' ? classes.colorInherit : color !== 'default' && classes["".concat(variant).concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(color))], size !== 'medium' && [classes["".concat(variant, "Size").concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(size))], classes["size".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(size))]], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.focusVisible, focusVisibleClassName),
    ref: ref,
    type: type
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: classes.label
  }, startIcon, children, endIcon));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(styles, {
  name: 'MuiButton'
})(Button));

/***/ }),

/***/ 34455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var MetaTags = function MetaTags(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Digito' : _ref$title,
      description = _ref.description,
      _ref$url = _ref.url,
      url = _ref$url === void 0 ? 'https://digito.se' : _ref$url,
      _ref$img = _ref.img,
      img = _ref$img === void 0 ? 'https://digito.se/share-pic.jpg' : _ref$img;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      name: "description",
      content: description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      itemProp: "name",
      content: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      itemProp: "description",
      content: description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      itemProp: "image",
      content: img
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      property: "og:url",
      content: url
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      property: "og:type",
      content: "website"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      property: "og:title",
      content: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      property: "og:description",
      content: description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      property: "og:image",
      content: img
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      name: "twitter:card",
      content: "summary_large_image"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      name: "twitter:title",
      content: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      name: "twitter:description",
      content: description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      name: "twitter:image",
      content: img
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);

/***/ }),

/***/ 11429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71383);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18598);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);



var _excluded = ["children"];

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var Wave = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].svg */ .Z.svg(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  margin-bottom: -10px;\n  background: ", ";\n  background: ", ";\n  background: ", ";\n  path {\n    fill: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return "-moz-linear-gradient(bottom, ".concat(theme.palette.GREEN, " 0%, ").concat(theme.palette.BEIGE, " 30%);");
}, function (_ref2) {
  var theme = _ref2.theme;
  return "-webkit-linear-gradient(bottom, ".concat(theme.palette.GREEN, " 0%, ").concat(theme.palette.BEIGE, " 30%);");
}, function (_ref3) {
  var theme = _ref3.theme,
      direction = _ref3.direction;
  return "linear-gradient(to ".concat(direction === 'top' ? 'top' : 'bottom', ", ").concat(theme.palette.GREEN, " 0%, ").concat(theme.palette.BEIGE, " 20%);");
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.GREEN;
});

var WaveWrapper = function WaveWrapper(_ref5) {
  var children = _ref5.children,
      props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref5, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Wave, _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve"
  }, props), {}, {
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (WaveWrapper);

/***/ }),

/***/ 91894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71383);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18598);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(282);


var _templateObject;



var Button = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  margin: 10px 0 8px;\n"])));
/* harmony default export */ __webpack_exports__["Z"] = (Button);

/***/ }),

/***/ 97895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(18598);
;// CONCATENATED MODULE: ./src/assets/images/landing-page-mock.png
/* harmony default export */ var landing_page_mock = ({"src":"/_next/static/media/landing-page-mock.2a5a1435.png","height":2094,"width":1394,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAMAAAAGL8UJAAAATlBMVEXM3t6hkZv7+vri5eV4mZxMaXFceIDi3+G7oarLvMHd2tyVkZxHZnAimYoemYlEeXmVs7O30dBNQk3v7vDm5uiDm6Dk8/Fzzr+ypa7m//zedFWjAAAAE3RSTlP88/7+8QCi+/79+YwZ/fyG/P4Xy1ioFgAAAAlwSFlzAAALEwAACxMBAJqcGAAAADRJREFUeJwFwQsCgBAQQMHnTylqV3T/i5rBD18D17zjCR8lc0gqmWTVKfyPCC12K4TXLLMBKJQBvbhgA/kAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./src/components/button/Button.js
var Button = __webpack_require__(91894);
// EXTERNAL MODULE: ./src/components/MetaTags.js
var MetaTags = __webpack_require__(34455);
// EXTERNAL MODULE: ./src/components/typography/index.js + 5 modules
var typography = __webpack_require__(50677);
// EXTERNAL MODULE: ./src/components/WaveWrapper.js
var WaveWrapper = __webpack_require__(11429);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/pages/index.js


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;













var WhatIsDigito = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 66).then(__webpack_require__.bind(__webpack_require__, 18066));
}, {
  ssr: false,
  loading: function loading() {
    return null;
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(18066)];
    }
  }
});
var HowItWorkSection = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(261), __webpack_require__.e(440)]).then(__webpack_require__.bind(__webpack_require__, 46440));
}, {
  ssr: false,
  loading: function loading() {
    return null;
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(46440)];
    }
  }
});
var PricingPlanSection = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(415), __webpack_require__.e(106)]).then(__webpack_require__.bind(__webpack_require__, 18106));
}, {
  ssr: false,
  loading: function loading() {
    return null;
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(18106)];
    }
  }
});
var ContactUsSection = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 514).then(__webpack_require__.bind(__webpack_require__, 73514));
}, {
  ssr: false,
  loading: function loading() {
    return null;
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(73514)];
    }
  }
});
var BeigeBackground = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 95vh;\n  z-index: 0;\n  background: ", ";\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.BEIGE;
});
var Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: ", ";\n  position: relative;\n  align-items: center;\n  color: white;\n  display: flex;\n  min-height: 100vh;\n  @media (max-width: ", ") {\n    justify-content: center;\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.BEIGE;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakPoints.mobile;
});
var ContentWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  z-index: 999;\n  align-items: center;\n  color: ", ";\n  display: flex;\n  justify-content: space-between;\n  margin: auto;\n  max-width: ", ";\n  padding: ", ";\n  width: 100%;\n  @media (max-width: ", ") {\n    padding-top: unset;\n    flex-direction: column;\n  }\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.BLACK;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.width.medium;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.xlarge;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakPoints.mobile;
});
var StyledWaveWrapper = (0,emotion_styled_browser_esm/* default */.Z)(WaveWrapper/* default */.Z)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin-bottom: -10px;\n"])));
var PitchWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin: ", ";\n  @media (max-width: ", ") {\n    align-items: center;\n    text-align: center;\n  }\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.medium;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakPoints.mobile;
});
var Title = (0,emotion_styled_browser_esm/* default */.Z)(typography.H1)(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: 'Rajdhani', sans-serif;\n  font-size: 52px;\n  letter-spacing: 5px;\n  margin-bottom: -5px;\n"])));
var SubTitle = emotion_styled_browser_esm/* default.span */.Z.span(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: 18px;\n  letter-spacing: 2px;\n  @media (max-width: ", ") {\n    font-size: 16px;\n  }\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakPoints.mobile;
});
var Text = (0,emotion_styled_browser_esm/* default */.Z)(typography.P)(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  line-height: 20px;\n  font-size: 16px;\n  letter-spacing: 2px;\n  max-width: ", ";\n  @media (max-width: ", ") {\n    font-size: 14px;\n  }\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.width.xsmall;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.breakPoints.mobile;
});
var ImgWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: ", ";\n  width: 45%;\n  @media (max-width: ", ") {\n    width: 42%;\n    margin-top: ", ";\n  }\n  @media (max-width: ", ") {\n    width: 45%;\n    margin: unset;\n  }\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.space.medium;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.breakPoints.mobile;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.space.xxxlarge;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.breakPoints.mobileS;
});

var Index = function Index() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
      title: "DIGITO - Allt du beh\xF6ver i en l\xE4nk!",
      description: "Hantera och dela dina sociala kanaler p\xE5 en och samma plattform"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BeigeBackground, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ContentWrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PitchWrapper, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
            children: "DIGITO"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubTitle, {
            children: "- Allt du beh\xF6ver i en l\xE4nk!"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text, {
            children: "Digito ger dig frihet att samla alla dina sociala kanaler p\xE5 en samlad plattform, eller varf\xF6r inte anv\xE4nda det som ett visitkort!"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            href: "/login",
            variant: "contained",
            children: "Registrera dig nu!"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ImgWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: landing_page_mock,
            alt: "digito-logo",
            layout: "responsive",
            placeholder: "blur"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledWaveWrapper, {
        direction: "top",
        viewBox: "0 0 1440 320",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fillOpacity: "1",
          d: "M0,128L80,128C160,128,320,128,480,149.3C640,171,800,213,960,234.7C1120,256,1280,256,1360,256L1440,256L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(WhatIsDigito, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(HowItWorkSection, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(PricingPlanSection, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactUsSection, {})]
  });
};

Index.displayName = 'Index';
Index.layoutOptions = {
  backgroundColor: '#f4f4f4',
  noBottomSpacing: true,
  footer: true
};
/* harmony default export */ var pages = (Index);

/***/ }),

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(97895);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,774,888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);